<template>
  <button-base v-if="showWebShareButton" :channel="channelInfo" :show-button-labels="showLabel" :label="label"
               :title="label" :aria-label="label" icon-class="icon-share" @click="launchShare" />

  <span v-else />
</template>

<script>
import ButtonBase from './button-base'
import WebShareApiMixin from '@/share/campaign/web-share-api-mixin'
import webShareSupported from '@/utils/web-share-supported'

export default {
  components: { ButtonBase },

  mixins: [WebShareApiMixin],

  props: {
    label: {
      type: String,
      required: true
    },

    showLabel: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    channelInfo() {
      return {
        kind: 'web_share_api',
        medium: 'web-share-api',
        mobileOnly: false
      }
    },

    showWebShareButton() {
      return webShareSupported()
    }
  }
}
</script>
